// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gfilm-responsive-dialog.v-dialog--fullscreen{bottom:0;box-shadow:none;display:flex;flex-flow:column nowrap;justify-content:flex-end;max-height:95vh;pointer-events:none;top:auto}.gfilm-responsive-dialog.v-dialog--fullscreen:focus-visible{outline:none}.gfilm-responsive-dialog.v-dialog--fullscreen:focus-visible>.gfilm-responsive-dialog__content{outline:2px solid #fff;outline-offset:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
